<template>
  <div class="wrapper-full up-down">
    <table class="table" style="font-size: 50px">
      <tbody>
        <tr>
          <td style="width: 60%">
            <Radio
              :index="0"
              :checked="updowns[0].checked"
              eventName="setUpDown"
              @setUpDown="setUpDown"
            >
              {{ $t("langcfg.txtUp") }}
            </Radio>
          </td>
        </tr>
        <tr>
          <td style="width: 60%">
            <div class="splitor-h-middle"></div>
          </td>
        </tr>
        <tr>
          <td style="width: 70%">
            <Radio
              :index="1"
              :checked="updowns[1].checked"
              eventName="setUpDown"
              @setUpDown="setUpDown"
            >
              {{ $t("langcfg.txtDown") }}
            </Radio>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Radio from "../../common/components/Radio";
export default {
  name: "UpDownSelector",
  data() {
    return {
      updowns: [
        { key: "up", checked: true, label: "txtUp", value: "up" },
        { key: "down", checked: false, label: "txtDown", value: "down" }
      ]
    };
  },
  props: {
    value: {
      type: String,
      default: "up"
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      for (let id in this.updowns) {
        this.updowns[id].checked = this.updowns[id].value === this.value;
      }
    },
    setUpDown(index) {
      let updown = "";
      for (let id = 0; id < this.updowns.length; id++) {
        if (id === index) {
          updown = this.updowns[id].value;
          this.updowns.splice(index, 1, {
            key: this.updowns[id].key,
            label: this.updowns[id].label,
            checked: true,
            value: this.updowns[id].value
          });
        } else {
          this.updowns.splice(id, 1, {
            key: this.updowns[id].key,
            label: this.updowns[id].label,
            checked: false,
            value: this.updowns[id].value
          });
        }
      }
      this.$emit("input", updown);
    }
  },
  watch: {
    value() {
      this.init();
    }
  },
  components: {
    Radio
  }
};
</script>
<style lang="less" scoped>
.el-radio {
  width: 90%;
  color: white;
  line-height: @header-fs+30px;
}
.btn-oprator {
  height: @header-fs+30px;
}
.btn-oprator:active {
  background: @btn-active-color;
}
.btn-oprator::before {
  content: "\00A0\00A0";
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.up-down {
  font-size: @header-fs;
  padding-top: 20px;
  height: 100%;
  color: white;
  padding-left: @content-to-left;
  .btn-oprator:hover {
    .label {
      color: @btn-hover-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/UpDownSelector.vue